<div class="header">
  <div class="title">Smart Email</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<form [formGroup]="projectForm">
  <!-- Subject -->
  <div class="flex flex-col gt-xs:flex-row mt-3">
    <mat-form-field class="subject flex-auto">
      <mat-label>Deal Email Address</mat-label>
      <input matInput [formControlName]="'email'" />
    </mat-form-field>
  </div>

  <!-- Body -->

  <div class="actions">
    <div class="formatting"></div>

    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>
      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        #btnFocus="matButton"
        [autofocus]="btnFocus.focus()"
        (click)="copyDealEmailAddress()"
      >
        <span>Copy To Clipboard</span>
      </button>
    </div>
  </div>
</form>
